import { ENDPOINTS } from "./endpoints";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";
import { infoFecthCertificacionI, makeCertificacion } from "dtos/certificacion";

export const getCertificaciones = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFecthCertificacionI>
  >({
    method: "GET",
    uri: ENDPOINTS.CERTIFICACIONES_PAGINADO,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  const elementosFormated = response.elementos.map((ctElemento) =>
    makeCertificacion(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };

  /* return {
    page: 1,
    cantidad: 10,
    elementos: (response as unknown as infoFecthCertificacionI[]).map(
      (ctElemento) => makeCertificacion(ctElemento),
    ),
  }; */
};

export const postCertificacion = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFecthCertificacionI>({
    method: "POST",
    uri: ENDPOINTS.CERTIFICACIONES,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeCertificacion(response);
};

export const putCertificacion = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFecthCertificacionI>({
    method: "PUT",
    uri: ENDPOINTS.CERTIFICACIONES,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeCertificacion(response);
};

export const deleteCertificacion = async (id: any) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.CERTIFICACIONES + "/" + id,
  });
  return response;
};
